import { Box, Tooltip, tooltipClasses, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

import HNSColors from "../../../../../ui library/HNSColors";
import { STRINGS } from "../../config/strings";

const CustomStyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: HNSColors.tertiary[975],
    borderRadius: "8px",
    padding: "6px 12px",
    boxShadow: `0px 3px 12px ${HNSColors.neutrals[400]}`,
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: HNSColors.tertiary[975],
  },
}));

export default function CustomMapPinTooltip({ data, color, children }) {
  const customContent = (
    <Box>
      <Typography style={{ color: color, fontSize: "14px", fontWeight: "400" }}>
        {data?.inNetwork ? STRINGS.IN_NETWORK : STRINGS.OUT_NETWORK}
        <span style={{ color: HNSColors.neutrals[100] }}>{" - "}</span>
      </Typography>
      <Typography
        style={{ color: HNSColors.neutrals[100], fontSize: "12px", fontWeight: "400" }}
      >{`${data?.receivingClients ? STRINGS.RECEIVING_CLIENTS : STRINGS.NOT_RECEIVING_CLIENTS}`}</Typography>
    </Box>
  );

  return (
    <CustomStyledTooltip title={customContent} placement="bottom" arrow>
      <div>{children}</div>
    </CustomStyledTooltip>
  );
}
